module.exports = __webpack_public_path__ + "static/media/1001626DO.730f5e1a.jpg";